import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Navigation from "./components/Navigation";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import Welcome from "./components/Welcome";
import { Container } from "react-bootstrap";

const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Container className="mt-4">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <AuthenticatedTemplate>
                    <Welcome />
                  </AuthenticatedTemplate>
                  <UnauthenticatedTemplate>
                    <Home />
                  </UnauthenticatedTemplate>
                </>
              }
            />
            <Route
              path="/profile"
              element={
                <>
                  <AuthenticatedTemplate>
                    <Profile />
                  </AuthenticatedTemplate>
                  <UnauthenticatedTemplate>
                    <Navigate to="/" replace />
                  </UnauthenticatedTemplate>
                </>
              }
            />
          </Routes>
        </Container>
      </div>
    </Router>
  );
};

export default App;
